import { NavTabItem, NavTabs } from '@app/components/NavTabs'
import MaintenancePage from '@app/routes/Maintenance/MaintenancePage'
import {
  IGlobalConfigurationState,
  IGlobalDevelopmentProjectClients,
} from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Link, Route, RouteComponentProps, Switch } from 'react-router-dom'
import { Button } from 'reactstrap'
import { actionCreators, ISiteListState } from '../modules/siteList'
import SiteList from './SiteList'
import SuggestionsList from './SuggestionsList'

interface IComponentRouteProps {
  slug: string
}

type ComponentProps = ISiteListState &
  IGlobalConfigurationState &
  IGlobalDevelopmentProjectClients &
  typeof actionCreators &
  RouteComponentProps<IComponentRouteProps>

export default class SiteListPage extends React.PureComponent<ComponentProps> {
  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.props.loadClient(this.props.match.params.slug)
  }

  public render() {
    return (
      <DocumentTitle
        title={`${this.props.client ? this.props.client.name : 'Sites'}`}
      >
        <div className='container pt-3'>
          <div className='d-flex flex-row justify-content-between'>
            <div className='ml-2'>{this._renderLogo()}</div>
            <div>
              <Link
                to={`/development/client/${
                  this.props.client ? this.props.client.slug : ''
                }/sites/add`}
                className='align-self-center'
              >
                <Button size='sm' color='primary'>
                  <FontAwesomeIcon icon={['fal', 'plus']} fixedWidth />
                  <span>New Site</span>
                </Button>
              </Link>
            </div>
          </div>
          <div>
            <div>
              <div className='mb-3 mt-3'>
                <NavTabs>
                  <NavTabItem
                    exact
                    iconName='chart-line'
                    label='Sites'
                    to={this.props.match.url}
                  />
                  <NavTabItem
                    iconName='list'
                    label='Suggestions'
                    to={`${this.props.match.url}/suggestions`}
                  />
                </NavTabs>
              </div>
              <Switch>
                <Route
                  exact
                  path={this.props.match.path}
                  render={() => <SiteList {...this.props} />}
                />
                <Route
                  exact
                  path={`${this.props.match.path}/suggestions`}
                  render={() => <SuggestionsList {...this.props} />}
                />
                <Route component={MaintenancePage} />
              </Switch>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _renderLogo() {
    if (!this.props.client || !this.props.client.logo) {
      return null
    }

    return this.props.client.logo.availableSizes ? (
      <Link to={`/development/client/${this.props.client.slug}`}>
        <img
          className='logo-image'
          src={`${this.props.client.logo.baseStorageUrl}/${
            this.props.client.logo.availableSizes.h100w100
          }`}
          width={100}
          height={100}
        />
      </Link>
    ) : (
      <Link to={`/development/client/${this.props.client.slug}`}>
        <img
          src={`${this.props.client.logo.baseStorageUrl}/${
            this.props.client.logo.id
          }${this.props.client.logo.extension}`}
          width={100}
          height={100}
        />
      </Link>
    )
  }
}
